import {ICategory} from '../types/types';

export function checkCategoryProps(category: ICategory) {
    if (category.alias && category.id && category.contents && category.name) {
        return true;
    }
}
